import { useTranslation } from 'react-i18next';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { FieldGroup, FieldSet, FieldSeparator } from '@/components/ui/field';

import { useAboutData } from '../model/use-about-data';
import { UserInfoField, ServerInfoField, BuildInfoField, SupportInfoFields } from './components';

interface AboutModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AboutModal = ({ open, onOpenChange }: AboutModalProps) => {
  const { t } = useTranslation();
  const { isLoading, user, buildInfo, support } = useAboutData();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>{t('about.title', 'About RITA')}</DialogTitle>
        </DialogHeader>

        <FieldGroup>
          <FieldSet>
            <UserInfoField isLoading={isLoading} user={user} />
          </FieldSet>

          <FieldSet>
            <ServerInfoField isLoading={isLoading} buildInfo={buildInfo} />
          </FieldSet>

          <FieldSet>
            <BuildInfoField isLoading={isLoading} buildInfo={buildInfo} />
          </FieldSet>

          <FieldSeparator />

          <FieldSet>
            <SupportInfoFields support={support} />
          </FieldSet>
        </FieldGroup>
      </DialogContent>
    </Dialog>
  );
};
